<template>
    <section-slider :destroyMobile="destroyMobile" v-if="shouldMount" :key="componentKey">
        <div class="item item-slider" :key="`page-cloud-section-slider-${slilderIndex}`"
            v-for="(slider, slilderIndex) in sectionSliderData">
            <a :href="slider.news_link ? slider.news_link : 'javascript:;'">
                <img width="360" height="360" :src="slider.news_image_path" :alt="slider.news_image_alt" />
                <!-- description -->
                <div class="description">
                    <h3 class="smart-home--2 text-26 text-white fptplay-text__font-weight-700" v-html="slider.news_title"></h3>
                    <div class="mirror">
                        <span class="smart-home--3" v-text="slider.news_description"></span>
                        <a :href="slider.news_link" class="icon-right">

                            <div class="icon-right-item"></div>
                        </a>
                    </div>
                </div>
            </a>
        </div>
    </section-slider>
</template>
<style>
.mirror {
    position: relative
}

.icon-right {
    position: absolute;
    right: 0px;
    bottom: 40px;
}
</style>
<script>

export default {
    props: {
        sectionSliderData: {
            type: Array,
            default: [],
        },
        destroyMobile: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            componentKey: 0,
            shouldMount: true,
        }
    },


    mounted() {
        this.callCarousel()
    },

    methods: {
        callCarousel() {
            setTimeout(() => {

                const vm = this;
                this.$nextTick(() => {
                    const slider_features = $(this.$el).find(".slider-features");

                    $(slider_features).on('initialized.owl.carousel', function (e) {
                        vm.showHideBtn(e);
                    })


                    $(slider_features).owlCarousel({
                        loop: false,
                        autoplay: false,
                        autoplayTimeout: 3000,
                        smartSpeed: 300,
                        margin: 16,
                        items: 3,
                        autoWidth: false,
                        dots: false,
                        // nav: true,
                        lazyLoad: true,
                        responsiveClass: true,
                        responsive: {
                            // breakpoint from up
                            320: {
                                items: 1,
                            },
                            768: {
                                items: 2,
                            },
                            1024: {
                                items: 3,
                            },
                        }
                    });

                    // Go to the previous item
                    $('.p_slider_features').click(function () {
                        // With optional speed parameter
                        // Parameters has to be in square bracket '[]'
                        slider_features.trigger('prev.owl.carousel', [300]);
                    })
                    // Go to the next item
                    $('.n_slider_features').click(function () {
                        slider_features.trigger('next.owl.carousel');
                    })

                    $(slider_features).on('changed.owl.carousel', function (e) {
                        vm.showHideBtn(e);
                    })
                });
            }, 500);
        },
        showHideBtn(e) {
            let pageSize = e.page.size;
            let numOfItems = e.item.count;
            let currentItem = e.item.index;

            if (currentItem <= 0) {
                $('.p_slider_features').css('visibility', 'hidden');
            } else {
                $('.p_slider_features').css('visibility', 'visible');
            }

            if (currentItem + pageSize >= numOfItems) {
                $('.n_slider_features').css('visibility', 'hidden');
            } else {
                $('.n_slider_features').css('visibility', 'visible');
            }
        },
        remountComponent() {
            this.shouldMount = false;
            this.componentKey += 1;
            this.$nextTick(() => {
                this.shouldMount = true;
            });
        }
    },
    watch: {
        sectionSliderData(newValues) {
            this.remountComponent();

        }
    }
};
</script>
<style scoped>
    .smart-home--2{
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
    }
    .smart-home--3{
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
    }
</style>
